import { BCMSDefaultModel, BCMSRecord, useBCMSContext, useParams, Workflow } from "@bcm-dev/bcms-vite";
import TemplateDetailsPage from "components/pages/TemplateDetailsPage";
import Classes, { Account, ACHTemplate, CompanyAccount, Participant } from "model";
import React from "react";

// Steps of the workflow
const steps = [ TemplateDetailsPage ];

/**
 * @function AddACHTemplateWorkflow
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for adding an ach template.
 */
export default function AddACHTemplateWorkflow(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { stepID } = useParams();
    // Get the inital state of the workflow
    const value = getDefault(context);
    // Return the workflow component
    return <Workflow value={ value } steps={ steps } step={ stepID } />;
}
// Return the steps of the workflow
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {Controller} controller - A global controller.
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefault = controller => {
    
    // Return the default workflow state
    return { 
        data: {
            template: ACHTemplate.init({ 
                id: ACHTemplate.nextID(),
                denyAccessToUserIDs: []
            }),
            companyAccounts: CompanyAccount.initAll(),
            offsetAccounts: Account.initAllBusinessAsset(),
            achFromAccounts: {
                accounts: [] // always empty by default since we are making a new payment.
            }, 
            achToParticipants: {
                participants: [] // always empty by default since we are making a new payment.
            }, 
            participants: Participant.initAll().map(item => {
                // "isSelected" will be used to keep track of row selection.
                item.isSelected = undefined;
                return item;
            }),
            groupSearchValue: "",
            selectedOffsetAccount: { account: undefined }
        },
        ui: {
            createdTemplateName: BCMSDefaultModel.achTemplate().name,
            showOneTimeACHModal: { isActive: true },
            achParticipantsModalIsOpen: { isActive: false },
            showSecCode: { isActive: false },
            showUnsavedChangesBanner: { isActive: false },
            showSavedTemplateBanner: { isActive: false },
            showTemplateNameAlreadyExistsBanner: { isActive: false },
            companySelectIsActive: { isActive: false },
            offsetAccountSelectIsActive: { isActive: false },
            transactionTypeSelectIsActive: { isActive: false },
            secCodeSelectIsActive: { isActive: false }
        }
    };
};